<div class="page-header" (click)="$event.stopPropagation()">
  <div class="left">
    <a [routerLink]="['/']">
      <img src="assets/inwedio-logo.svg" alt="Inwedio" class="logo" />
    </a>
    <!-- Organisation selector (hidden on quest route) -->
    <div
      class="org-select"
      #orgTrigger
      (click)="toggleOrgDropdown()"
      *ngIf="!isQuestRoute"
    >
      <span
        class="org-name"
        *ngIf="currentOrgId$ | async as oid; else selectOrg"
      >
        {{ (currentOrg$ | async)?.name || 'Select organisation' }}
      </span>
      <ng-template #selectOrg>Select organisation</ng-template>
      <!-- <span class="arrow" aria-hidden="true">▾</span> -->
    </div>

    <!-- Project name + settings -->
    <div class="project-wrap" *ngIf="currentProjectIRI$ | async">
      <div class="project-name">
        <ng-container *ngIf="projectLabel$ | async as pname">
          <span *ngIf="!editingProject" (click)="startEditProjectName(pname)">{{
            pname
          }}</span>
          <!-- <span class="arrow" aria-hidden="true">▾</span> -->

          <input
            *ngIf="editingProject"
            [(ngModel)]="editedProjectName"
            (blur)="commitProjectName()"
            (keydown.enter)="commitProjectName()"
            (keydown.escape)="cancelEditProjectName()"
            class="project-input"
          />
        </ng-container>
      </div>
      <!-- <div style="position: relative; left: 6px; top: 2px">
        <nw-icon
          *ngIf="hasProject$ | async"
          #projectSettingsTrigger
          (click)="toggleProjectSettings()"
          type="settings"
          [outlined]="true"
        >
        </nw-icon>
       
      </div> -->

      <div
        class="project-settings-popup"
        #projectSettingsPopup
        *ngIf="showProjectSettings"
      >
        <div class="row">
          <label>Font family</label>
          <nw-font-family-selector
            [fontFamily]="projectFontFamily"
            [emitOnly]="true"
            (fontSelected)="onProjectFontSelected($event)"
          ></nw-font-family-selector>
        </div>
        <div class="row">
          <label>Color palette</label>
          <div class="palette-list">
            <div
              class="palette-row"
              *ngFor="let row of projectPaletteRows; let i = index"
            >
              <input class="name" [(ngModel)]="row.name" placeholder="name" />
              <input
                class="color"
                [(ngModel)]="row.color"
                placeholder="#RRGGBB"
              />
              <button
                class="remove"
                (click)="removePaletteRow(i)"
                type="button"
              >
                ✕
              </button>
            </div>
            <button class="add" (click)="addPaletteRow()" type="button">
              + Add color
            </button>
          </div>
        </div>
        <!-- <div class="actions">
          <button type="button" class="save" (click)="saveProjectSettings()">
            Save
          </button>
        </div> -->
      </div>
    </div>

    <!-- Organisation dropdown (hidden on quest route) -->
    <div
      class="org-dropdown"
      #orgDropdown
      *ngIf="showOrgDropdown && !isQuestRoute"
    >
      <div class="org-dropdown-list">
        <div
          class="org-item"
          *ngFor="let o of orgs$ | async"
          (click)="onSelectOrg(o.id)"
        >
          <div class="org-item-name">{{ o.name }}</div>
          <div class="org-item-role" *ngIf="myUserId$ | async as uid">
            <span *ngIf="o.roles?.[uid]?.type as role">[{{ role }}]</span>
          </div>
        </div>
        <div class="empty" *ngIf="(orgs$ | async)?.length === 0">
          No organisations
        </div>
      </div>
    </div>
  </div>
  <!-- User info (hidden on quest route) -->
  <div
    class="right"
    *ngIf="myUser$ | async as me; else questRight"
    [hidden]="isQuestRoute"
  >
    <div class="avatar">
      {{ (me.firstName || '?')[0] }}{{ (me.lastName || '')[0] }}
    </div>
    <div class="name">{{ me.firstName }} {{ me.lastName }}</div>
  </div>
  <ng-template #questRight>
    <div class="right" *ngIf="isQuestRoute"></div>
  </ng-template>
</div>
